
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.678 28.2h9.2c.9 0 .9 3.2 0 3.1h-9.2c-1 0-1-3.1 0-3.1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.572 15.395c2.96-.03 5.446-.054 5.906 3.805.334 3.21.221 6.645.11 10.034-.055 1.677-.11 3.344-.11 4.966 0 .563.034 1.197.07 1.867.168 3.138.379 7.062-2.67 8.133-.1.1-.2.1-.3.1h-33.4c-3.2 0-4.7-.7-5-4.3-.267-3.467-.178-7.022-.09-10.578.045-1.778.09-3.555.09-5.322v-1c-.01-.306-.025-.62-.04-.936-.136-2.886-.285-6.043 3.14-6.764 2.768-.607 6.082-.395 9.236-.193 1.518.098 2.999.193 4.364.193h17.9c.267 0 .532-.003.794-.005zm-27.588 3.033c-2.186-.15-5.53-.38-6.406.972-.3.5-.4 1.5-.3 2.5h39.1c0-.8-.1-1.5-.3-2.1-.426-1.192-1.142-1.224-2.148-1.27a16.99 16.99 0 01-.552-.03c-6.081-.601-12.43-.399-18.72-.199-3.121.1-6.228.199-9.28.199-.348 0-.832-.033-1.394-.072zM23.478 41.1h24.1c1.897-.474 1.732-2.386 1.58-4.153-.04-.47-.08-.928-.08-1.347v-8.7c0-.5 0-1.1.1-1.7h-38.6v7.6c0 .584-.066 1.276-.135 2.007-.251 2.65-.551 5.823 2.035 6.293 2.284.403 4.884.265 7.406.13 1.232-.065 2.445-.13 3.594-.13z"}})])
          )
        }
      }
    